webpackJsonp([222513340499783],{

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(133);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _Button = __webpack_require__(45);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _TextField = __webpack_require__(127);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _styles = __webpack_require__(11);
	
	var _reactToastify = __webpack_require__(158);
	
	__webpack_require__(147);
	
	var _constants = __webpack_require__(51);
	
	var _styles2 = __webpack_require__(240);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Enquiry = function (_React$Component) {
	  _inherits(Enquiry, _React$Component);
	
	  function Enquiry() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Enquiry);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      formdata: {
	        type: '',
	        name: '',
	        company: '',
	        mobile: '',
	        email: '',
	        months: '',
	        project: ''
	      }
	    }, _this.onChange = function (e) {
	      var formdata = _this.state.formdata;
	      formdata[e.target.id] = e.target.value;
	      _this.setState({ formdata: formdata });
	    }, _this.submitForm = function (post) {
	      var formdata = _this.state.formdata;
	      var payload = {
	        mtype: 'Project',
	        template: 'project',
	        type: _this.props.type,
	        name: formdata.name,
	        company: formdata.company,
	        mobile: formdata.mobile,
	        email: formdata.email,
	        months: formdata.months,
	        project: formdata.project,
	        resources: _this.props.data
	      };
	
	      _axios2.default.post(_constants.API.enquiry, payload).then(function (response) {
	        _reactToastify.toast.success('Your enquiry has been sent, thanks.');
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Enquiry.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        classes = _props.classes,
	        data = _props.data,
	        type = _props.type;
	    var formdata = this.state.formdata;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: classes.enquiry },
	      _react2.default.createElement(_reactToastify.ToastContainer, null),
	      _react2.default.createElement(
	        'div',
	        { className: classes.contents },
	        _react2.default.createElement(
	          'form',
	          { noValidate: true, autoComplete: 'off' },
	          _react2.default.createElement(_TextField2.default, {
	            id: 'name',
	            label: 'Name',
	            margin: 'normal',
	            fullWidth: true,
	            value: formdata.name,
	            onChange: function onChange(e) {
	              return _this2.onChange(e);
	            }
	          }),
	          _react2.default.createElement(_TextField2.default, {
	            id: 'company',
	            label: 'Company Name',
	            margin: 'normal',
	            fullWidth: true,
	            value: formdata.company,
	            onChange: function onChange(e) {
	              return _this2.onChange(e);
	            }
	          }),
	          _react2.default.createElement(_TextField2.default, {
	            id: 'mobile',
	            label: 'Mobile',
	            margin: 'normal',
	            fullWidth: true,
	            value: formdata.mobile,
	            onChange: function onChange(e) {
	              return _this2.onChange(e);
	            }
	          }),
	          _react2.default.createElement(_TextField2.default, {
	            id: 'email',
	            label: 'Email',
	            margin: 'normal',
	            value: formdata.email,
	            fullWidth: true,
	            onChange: function onChange(e) {
	              return _this2.onChange(e);
	            }
	          }),
	          _react2.default.createElement(_TextField2.default, {
	            id: 'months',
	            label: 'Months Required',
	            margin: 'normal',
	            value: formdata.months,
	            fullWidth: true,
	            onChange: function onChange(e) {
	              return _this2.onChange(e);
	            }
	          }),
	          _react2.default.createElement(_TextField2.default, {
	            id: 'project',
	            label: 'Brief Description of Project',
	            fullWidth: true,
	            margin: 'normal',
	            rows: 3,
	            multiline: true,
	            value: formdata.project,
	            onChange: function onChange(e) {
	              return _this2.onChange(e);
	            }
	          }),
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              color: 'secondary',
	              style: { background: '#924B94' },
	              variant: 'raised',
	              className: classes.feedbackFormSubmit,
	              onClick: function onClick() {
	                return _this2.submitForm();
	              }
	            },
	            'Submit Enquiry'
	          )
	        )
	      )
	    );
	  };
	
	  return Enquiry;
	}(_react2.default.Component);
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(Enquiry);
	module.exports = exports['default'];

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _mixins = __webpack_require__(31);
	
	var styles = function styles(theme) {
	  return {
	    contents: _extends({}, (0, _mixins.Contents)(theme)),
	    centred: _extends({}, (0, _mixins.Centred)(theme)),
	    enquiry: {
	      marginTop: theme.spacing.unit * 5,
	      marginBottom: theme.spacing.unit * 10
	    },
	    feedbackFormSubmit: {
	      marginTop: theme.spacing.unit * 5
	    }
	  };
	};
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Scaffolding = function (_React$Component) {
	  _inherits(Scaffolding, _React$Component);
	
	  function Scaffolding() {
	    _classCallCheck(this, Scaffolding);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.count = {};
	    _this.inc = _this.inc.bind(_this);
	    return _this;
	  }
	
	  Scaffolding.prototype.inc = function inc(type) {
	    var count = this.count;
	    count[type] = this.count[type] + 1;
	  };
	
	  Scaffolding.prototype.reset = function reset() {
	    this.count = {
	      contact: 0,
	      content: 0,
	      content_link: 0,
	      quote: 0,
	      text: 0,
	      list: 0,
	      boxes: 0,
	      image: 0
	    };
	  };
	
	  Scaffolding.prototype.render = function render() {
	    var _props = props,
	        children = _props.children;
	
	    {
	      children;
	    }
	  };
	
	  return Scaffolding;
	}(_react2.default.Component);
	
	exports.default = Scaffolding;
	module.exports = exports['default'];

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _styles = __webpack_require__(11);
	
	var _enquiry = __webpack_require__(239);
	
	var _enquiry2 = _interopRequireDefault(_enquiry);
	
	var _styles2 = __webpack_require__(34);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contacter = (0, _styles.withStyles)(_styles3.default)(function (props) {
	  var selected = props.selected,
	      contents = props.contents,
	      type = props.type,
	      inc = props.inc,
	      count = props.count,
	      classes = props.classes;
	
	  var data = contents.filter(function (x) {
	    return x.type === type;
	  })[count[type]].content;
	  inc(type);
	  return data && _react2.default.createElement(
	    'div',
	    { className: classes.page },
	    _react2.default.createElement(
	      'div',
	      { className: classes.contents },
	      _react2.default.createElement(
	        'div',
	        { className: classes.boxer },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(classes.layout, classes.margins) },
	          data.primary.step && _react2.default.createElement(
	            _Typography2.default,
	            { variant: 'title' },
	            data.primary.step.text
	          ),
	          _react2.default.createElement(
	            _Typography2.default,
	            { variant: 'headline' },
	            data.primary.title.text
	          ),
	          _react2.default.createElement(
	            _Typography2.default,
	            { variant: 'subheading' },
	            data.primary.subtitle.text
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: classes.boxerContents },
	          _react2.default.createElement(
	            _Grid2.default,
	            { container: true, spacing: 40 },
	            _react2.default.createElement(
	              _Grid2.default,
	              { item: true, xs: 12 },
	              _react2.default.createElement(
	                _Typography2.default,
	                null,
	                'Selected Resources'
	              )
	            ),
	            _react2.default.createElement(_Grid2.default, { container: true, direction: 'row' }),
	            selected.map(function (item) {
	              return _react2.default.createElement(
	                _Grid2.default,
	                { item: true, className: classes.selectedResource },
	                _react2.default.createElement(
	                  _Typography2.default,
	                  { variant: 'caption', style: { color: '#fff' } },
	                  item
	                )
	              );
	            })
	          ),
	          _react2.default.createElement(_enquiry2.default, { data: selected, type: data.type })
	        )
	      )
	    )
	  );
	});
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(Contacter);
	module.exports = exports['default'];

/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _styles = __webpack_require__(11);
	
	var _styles2 = __webpack_require__(34);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contenter = (0, _styles.withStyles)(_styles3.default)(function (props) {
	  var contents = props.contents,
	      type = props.type,
	      inc = props.inc,
	      count = props.count,
	      classes = props.classes,
	      key = props.key;
	
	  var data = contents.filter(function (x) {
	    return x.type === type;
	  })[count[type]].content;
	  inc(type);
	  return data && _react2.default.createElement(
	    'div',
	    { className: classes.page, key: key },
	    _react2.default.createElement(
	      'div',
	      { className: classes.contents },
	      _react2.default.createElement(
	        'div',
	        { className: classes.contenter },
	        _react2.default.createElement(
	          'div',
	          { className: classes.layout },
	          _react2.default.createElement(
	            _Grid2.default,
	            { container: true, spacing: 40 },
	            _react2.default.createElement(
	              _Grid2.default,
	              { item: true, xs: 12 },
	              _react2.default.createElement(
	                _Typography2.default,
	                { variant: 'headline' },
	                data.primary.title.text
	              ),
	              _react2.default.createElement(
	                _Typography2.default,
	                { variant: 'subheading' },
	                data.primary.subtitle1.text
	              )
	            ),
	            data.items.map(function (item, i) {
	              return _react2.default.createElement(
	                _Grid2.default,
	                { item: true, xs: 12, key: i },
	                item.image.localFile && _react2.default.createElement('div', {
	                  className: classes.contenterImage,
	                  src: item.image.localFile.childImageSharp.original,
	                  style: {
	                    backgroundImage: 'url(' + item.image.localFile.childImageSharp.original.src + ')'
	                  }
	                }),
	                _react2.default.createElement(
	                  _Typography2.default,
	                  { variant: 'headline' },
	                  item.title.text
	                ),
	                _react2.default.createElement(
	                  _Typography2.default,
	                  { variant: 'subheading' },
	                  item.subtitle1.text
	                ),
	                _react2.default.createElement('div', {
	                  dangerouslySetInnerHTML: {
	                    __html: item.content && item.content.html
	                  },
	                  className: classes.richText
	                })
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	});
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(Contenter);
	module.exports = exports['default'];

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPlayer = __webpack_require__(89);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _styles = __webpack_require__(11);
	
	var _constants = __webpack_require__(51);
	
	var _styles2 = __webpack_require__(34);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = (0, _styles.withStyles)(_styles3.default)(function (props) {
	  var image = props.image,
	      video = props.video,
	      gradient = props.gradient;
	  var urls = video.urls,
	      poster = video.poster;
	
	
	  var header = '';
	
	  if (urls !== undefined && poster !== undefined) {
	    header = _react2.default.createElement(_reactPlayer2.default, {
	      url: urls[0].src,
	      width: '100%',
	      height: '100%',
	      loop: true,
	      autoPlay: true,
	      playing: true,
	      muted: true,
	      style: { minHeight: 500, maxHeight: '99vh' }
	    });
	  } else if (image.src && image.sizes) {
	    header = _react2.default.createElement('img', { src: image.src, style: { width: '100%', height: '100vh' } });
	  } else if (gradient) {
	    header = _react2.default.createElement('img', {
	      style: {
	        backgroundImage: _constants.GRADIENTS[gradient],
	        height: '100vh',
	        width: '100%'
	      }
	    });
	  } else {
	    header = _react2.default.createElement('img', {
	      style: {
	        backgroundImage: 'linear-gradient(to right top, #b8557b, #ba398b, #ae1da6, #8c17c9, #072ff0)',
	        height: '100vh',
	        width: '100%'
	      }
	    });
	  }
	
	  return header;
	});
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(Header);
	module.exports = exports['default'];

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(11);
	
	var _styles2 = __webpack_require__(34);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Imager = (0, _styles.withStyles)(_styles3.default)(function (props) {
	  var contents = props.contents,
	      type = props.type,
	      inc = props.inc,
	      count = props.count,
	      classes = props.classes;
	
	  var data = contents.filter(function (x) {
	    return x.type === type;
	  })[count[type]].content.items[0];
	  inc(type);
	  return data && _react2.default.createElement('div', {
	    className: classes.contenterImage,
	    style: {
	      backgroundImage: 'url(' + data.image.localFile.childImageSharp.original.src + ')'
	    }
	  });
	});
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(Imager);
	module.exports = exports['default'];

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _styles = __webpack_require__(11);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _styles2 = __webpack_require__(34);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Leader = (0, _styles.withStyles)(_styles3.default)(function (props) {
	  var topper = props.topper,
	      classes = props.classes;
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.page },
	    _react2.default.createElement(
	      'div',
	      { className: classes.contents },
	      _react2.default.createElement(
	        'div',
	        { className: classes.lead },
	        _react2.default.createElement(
	          _Grid2.default,
	          { container: true, spacing: 40 },
	          _react2.default.createElement(
	            _Grid2.default,
	            { item: true, xs: 12 },
	            _react2.default.createElement('div', {
	              dangerouslySetInnerHTML: {
	                __html: topper.lead && topper.lead.html
	              },
	              className: (0, _classnames2.default)(classes.richText, classes.leadText)
	            })
	          )
	        )
	      )
	    )
	  );
	});
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(Leader);
	module.exports = exports['default'];

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _styles = __webpack_require__(11);
	
	var _relatedcontent = __webpack_require__(165);
	
	var _relatedcontent2 = _interopRequireDefault(_relatedcontent);
	
	var _styles2 = __webpack_require__(34);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Linker = (0, _styles.withStyles)(_styles3.default)(function (props) {
	  var contents = props.contents,
	      type = props.type,
	      inc = props.inc,
	      count = props.count,
	      classes = props.classes;
	
	  var data = contents.filter(function (x) {
	    return x.type === type;
	  })[count[type]].content;
	  inc(type);
	  return data && _react2.default.createElement(
	    'div',
	    { className: classes.page },
	    _react2.default.createElement(
	      'div',
	      { className: classes.contents },
	      _react2.default.createElement(
	        'div',
	        { className: classes.linker },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)(classes.layout, classes.margins) },
	          data.primary && _react2.default.createElement(
	            _Grid2.default,
	            { container: true, spacing: 40 },
	            _react2.default.createElement(
	              _Grid2.default,
	              { item: true, xs: 12 },
	              _react2.default.createElement(
	                _Typography2.default,
	                { variant: 'headline' },
	                data.primary.title1.text
	              ),
	              _react2.default.createElement(
	                _Typography2.default,
	                { variant: 'subheading' },
	                data.primary.subtitle1.text
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: classes.margins },
	            _react2.default.createElement(_relatedcontent2.default, { content: data })
	          )
	        )
	      )
	    )
	  );
	});
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(Linker);
	module.exports = exports['default'];

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _quote = __webpack_require__(68);
	
	var _quote2 = _interopRequireDefault(_quote);
	
	var _styles = __webpack_require__(11);
	
	var _styles2 = __webpack_require__(34);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Quoter = (0, _styles.withStyles)(_styles3.default)(function (props) {
	  var contents = props.contents,
	      type = props.type,
	      inc = props.inc,
	      count = props.count,
	      classes = props.classes;
	
	  var data = contents.filter(function (x) {
	    return x.type === type;
	  })[count[type]].content;
	  inc(type);
	  return data && _react2.default.createElement(
	    'div',
	    { className: classes.margins },
	    _react2.default.createElement(_quote2.default, {
	      quote: {
	        quote: data.primary.quote,
	        author: data.primary.author,
	        company: data.primary.company
	      }
	    })
	  );
	});
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(Quoter);
	module.exports = exports['default'];

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _mixins = __webpack_require__(31);
	
	var styles = function styles(theme) {
	  var _h, _topper, _lead, _lister, _boxer, _contenter, _contenterImage, _linker, _focuser, _focusSectionImage, _ref;
	
	  return _ref = {
	    contents: _extends({}, (0, _mixins.Contents)(theme)),
	    centred: _extends({}, (0, _mixins.Centred)(theme))
	  }, _ref['contents'] = _extends({}, (0, _mixins.Contents)(theme), {
	    maxWidth: 1200,
	    padding: '0 1.5rem 0 1.5rem'
	  }), _ref.mainFloat = _extends({}, (0, _mixins.MainFloat)(theme), {
	    marginTop: '-30%',
	    position: 'relative'
	  }), _ref.margins = _extends({}, (0, _mixins.Margins)(theme)), _ref.btn = _extends({}, (0, _mixins.Btn)(theme)), _ref.linkText = _extends({}, (0, _mixins.LinkText)(theme)), _ref.richText = _extends({}, (0, _mixins.RichText)(theme)), _ref.page = _extends({}, (0, _mixins.Page)(theme)), _ref.topper = (_topper = {
	    background: '#fff',
	    padding: '7rem 7rem 0 7rem'
	  }, _topper[theme.breakpoints.down('sm')] = {
	    padding: '2rem 2rem 0 2rem'
	  }, _topper['& h1'] = (_h = {
	    textTransform: 'uppercase',
	    fontWeight: 800,
	    lineHeight: 1
	  }, _h[theme.breakpoints.down('sm')] = {
	    fontSize: theme.typography.headline.fontSize,
	    wordBreak: 'break-word'
	  }, _h), _topper['& h3'] = {
	    textTransform: 'uppercase'
	  }, _topper), _ref.topper_teams_as_a_service = { color: theme.brand && theme.brand.taas.navText }, _ref.topper_fixed_cost_project = { color: theme.brand && theme.brand.fixed.navText }, _ref.lead = (_lead = {
	    background: '#fff',
	    padding: '3rem 7rem 3rem 7rem'
	  }, _lead[theme.breakpoints.down('sm')] = {
	    padding: '2rem 2rem 0 2rem'
	  }, _lead), _ref.leadText = {
	    fontSize: theme.typography.subheading.fontSize,
	    fontWeight: 400
	  }, _ref.lister = (_lister = {
	    background: '#fff',
	    padding: '3rem 7rem 3rem 7rem'
	  }, _lister[theme.breakpoints.down('sm')] = {
	    padding: '2rem 2rem 0 2rem'
	  }, _lister), _ref.listerItems = {
	    marginTop: theme.spacing.unit * 5
	  }, _ref.listerItem = {
	    padding: 20,
	    background: '#efefef',
	    marginBottom: 20
	  }, _ref.listerLink = {
	    marginTop: theme.spacing.unit * 2
	  }, _ref.listerImageContainer = {
	    display: 'flex',
	    justifyContent: 'center',
	    alignItems: 'center'
	  }, _ref.listerImage = {
	    height: 120,
	    width: 120,
	    borderRadius: 4
	  }, _ref.boxer = (_boxer = {
	    background: '#fff',
	    padding: '3rem 7rem 3rem 7rem'
	  }, _boxer[theme.breakpoints.down('sm')] = {
	    padding: '2rem 2rem 0 2rem'
	  }, _boxer), _ref.boxerContents = {
	    marginBottom: theme.spacing.unit * 10
	  }, _ref.selectedResource = {
	    background: '#7ED321',
	    margin: 20,
	    fontSize: 18,
	    color: "#fff"
	  }, _ref.contenter = (_contenter = {
	    background: '#fff',
	    padding: '3rem 7rem 3rem 7rem'
	  }, _contenter[theme.breakpoints.down('sm')] = {
	    padding: '2rem 2rem 0 2rem'
	  }, _contenter), _ref.contenterImage = (_contenterImage = {
	    height: 500,
	    backgroundSize: 'cover',
	    backgroundRepeat: 'no-repeat',
	    marginTop: theme.spacing.unit * 5,
	    marginBottom: theme.spacing.unit * 10
	  }, _contenterImage[theme.breakpoints.down('sm')] = {
	    height: 200
	  }, _contenterImage), _ref.linker = (_linker = {
	    background: '#fff',
	    padding: '3rem 7rem 7rem 7rem'
	  }, _linker[theme.breakpoints.down('sm')] = {
	    padding: '2rem 2rem 0 2rem'
	  }, _linker), _ref.focuser = (_focuser = {
	    background: '#fff',
	    padding: '1rem 7rem 3rem 7rem'
	  }, _focuser[theme.breakpoints.down('sm')] = {
	    padding: '2rem 2rem 0 2rem'
	  }, _focuser['& h1'] = {
	    marginBottom: theme.spacing.unit
	  }, _focuser), _ref.focusSectionImage = (_focusSectionImage = {
	    width: '100%',
	    height: 500,
	    backgroundSize: 'contain',
	    backgroundRepeat: 'no-repeat',
	    marginTop: theme.spacing.unit * 5,
	    marginBottom: theme.spacing.unit * 5
	  }, _focusSectionImage[theme.breakpoints.down('sm')] = {
	    height: 200
	  }, _focusSectionImage), _ref;
	};
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _styles = __webpack_require__(11);
	
	var _styles2 = __webpack_require__(34);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Topper = (0, _styles.withStyles)(_styles3.default)(function (props) {
	  var topper = props.topper,
	      classes = props.classes;
	
	  var theme = void 0;
	  if (topper.type) theme = topper.type.replace(/\s/g, '_');
	  return _react2.default.createElement(
	    'div',
	    { className: classes.contents },
	    _react2.default.createElement(
	      'div',
	      { className: classes.topper },
	      _react2.default.createElement(
	        _Grid2.default,
	        { container: true, spacing: 40 },
	        _react2.default.createElement(
	          _Grid2.default,
	          { item: true, xs: 12 },
	          _react2.default.createElement(
	            _Typography2.default,
	            { variant: 'subheading' },
	            topper.subtitle.text
	          ),
	          _react2.default.createElement(
	            _Typography2.default,
	            { variant: 'display1', className: classes['topper_' + theme] },
	            topper.title.text
	          )
	        )
	      )
	    )
	  );
	});
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(Topper);
	module.exports = exports['default'];

/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styles = __webpack_require__(11);
	
	var _dynamic = __webpack_require__(134);
	
	var _dynamic2 = _interopRequireDefault(_dynamic);
	
	var _header = __webpack_require__(135);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _topper = __webpack_require__(138);
	
	var _topper2 = _interopRequireDefault(_topper);
	
	var _leader = __webpack_require__(136);
	
	var _leader2 = _interopRequireDefault(_leader);
	
	var _linker = __webpack_require__(137);
	
	var _linker2 = _interopRequireDefault(_linker);
	
	var _contenter = __webpack_require__(597);
	
	var _contenter2 = _interopRequireDefault(_contenter);
	
	var _quoter = __webpack_require__(248);
	
	var _quoter2 = _interopRequireDefault(_quoter);
	
	var _imager = __webpack_require__(247);
	
	var _imager2 = _interopRequireDefault(_imager);
	
	var _contacter = __webpack_require__(246);
	
	var _contacter2 = _interopRequireDefault(_contacter);
	
	var _footer = __webpack_require__(41);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _styles2 = __webpack_require__(604);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ShotContent = function (_Scaffolding) {
	  _inherits(ShotContent, _Scaffolding);
	
	  function ShotContent() {
	    _classCallCheck(this, ShotContent);
	
	    return _possibleConstructorReturn(this, _Scaffolding.apply(this, arguments));
	  }
	
	  ShotContent.prototype.render = function render() {
	    var _props = this.props,
	        data = _props.data,
	        metadata = _props.metadata,
	        policies = _props.policies,
	        classes = _props.classes;
	    var mapper = data.mapper,
	        topper = data.topper,
	        contents = data.contents;
	
	
	    this.reset();
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_header2.default, {
	        image: topper.background_image,
	        video: topper.background_video,
	        gradient: topper.gradient
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: classes.mainFloat },
	        _react2.default.createElement(_topper2.default, { topper: topper }),
	        _react2.default.createElement(_leader2.default, { topper: topper }),
	        _react2.default.createElement(Layout, {
	          mapper: mapper,
	          contents: contents,
	          count: this.count,
	          inc: this.inc
	        })
	      ),
	      _react2.default.createElement(_footer2.default, { policies: policies })
	    );
	  };
	
	  return ShotContent;
	}(_dynamic2.default);
	
	var Layout = function Layout(props) {
	  var mapper = props.mapper,
	      contents = props.contents,
	      count = props.count,
	      inc = props.inc;
	
	  return mapper.map(function (type, key) {
	    switch (type) {
	      case 'image':
	        return _react2.default.createElement(_imager2.default, { contents: contents, type: type, inc: inc, count: count, key: key });
	        break;
	      case 'content':
	        return _react2.default.createElement(_contenter2.default, { contents: contents, type: type, inc: inc, count: count, key: key });
	        break;
	      case 'quote':
	        return _react2.default.createElement(_quoter2.default, { contents: contents, type: type, inc: inc, count: count, key: key });
	        break;
	      case 'contact':
	        return _react2.default.createElement(_contacter2.default, {
	          contents: contents,
	          type: type,
	          inc: inc,
	          count: count,
	          selected: [],
	          key: key
	        });
	        break;
	      case 'content':
	        return _react2.default.createElement(_contenter2.default, { contents: contents, type: type, inc: inc, count: count, key: key });
	        break;
	      case 'content_link':
	        return _react2.default.createElement(_linker2.default, {
	          contents: contents,
	          type: type,
	          inc: inc,
	          count: count,
	          key: key
	        });
	        break;
	      default:
	        break;
	    }
	  });
	};
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(ShotContent);
	module.exports = exports['default'];

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _mixins = __webpack_require__(31);
	
	var styles = function styles(theme) {
	  var _h, _lead, _layout, _contentImage;
	
	  return {
	    centred: _extends({}, (0, _mixins.Centred)(theme), {
	      background: '#fff'
	    }),
	    contents: _extends({}, (0, _mixins.Contents)(theme), {
	      background: '#fff',
	      maxWidth: 1200,
	      padding: '0 1.5rem 0 1.5rem'
	    }),
	    text: _extends({}, (0, _mixins.RichText)(theme)),
	    mainFloat: {
	      marginTop: '-30%',
	      position: 'relative'
	    },
	    page: _extends({}, (0, _mixins.Page)(theme)),
	    margins: _extends({}, (0, _mixins.Margins)(theme)),
	    topper: _extends({}, (0, _mixins.Topper)(theme), {
	      '& h1': (_h = {
	        textTransform: 'uppercase',
	        fontWeight: 800,
	        lineHeight: 1
	      }, _h[theme.breakpoints.down('sm')] = {
	        fontSize: theme.typography.headline.fontSize,
	        wordBreak: 'break-word'
	      }, _h),
	      '& p': {
	        textTransform: 'uppercase'
	      }
	    }),
	
	    lead: (_lead = {
	      padding: '0rem 7rem 0 7rem',
	      maxWidth: 1024
	    }, _lead[theme.breakpoints.down('sm')] = {
	      padding: '2rem 2rem 0 2rem'
	    }, _lead),
	
	    layout: (_layout = {
	      padding: '3rem 7rem 0 7rem',
	      maxWidth: 1024
	    }, _layout[theme.breakpoints.down('sm')] = {
	      padding: '2rem 2rem 0 2rem'
	    }, _layout),
	
	    shot: {
	      background: '#fff',
	      '& h1': {
	        textTransform: 'uppercase',
	        fontWeight: 800,
	        color: '#55198B'
	      },
	      '& h2': {
	        textTransform: 'uppercase',
	        fontWeight: 100,
	        color: '#333',
	        lineHeight: 1
	      },
	      '& h3': {
	        textTransform: 'uppercase',
	        fontWeight: 100,
	        lineHeight: 1
	      }
	    },
	    shotContents: {
	      background: '#fff'
	    },
	    contentImage: (_contentImage = {
	      height: 500,
	      backgroundSize: 'cover',
	      backgroundRepeat: 'no-repeat',
	      marginTop: theme.spacing.unit * 5,
	      marginBottom: theme.spacing.unit * 10
	    }, _contentImage[theme.breakpoints.down('sm')] = {
	      height: 200
	    }, _contentImage)
	  };
	};
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mapper = __webpack_require__(38);
	
	var _shot = __webpack_require__(603);
	
	var _shot2 = _interopRequireDefault(_shot);
	
	var _styles = __webpack_require__(11);
	
	var _site = __webpack_require__(43);
	
	var _site2 = _interopRequireDefault(_site);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Shot = function Shot(props) {
	  var policies = props.policies;
	
	  var metadata = (0, _mapper.mapMetaData)(props.data.shot);
	  var data = (0, _mapper.mapPage)(props.data.shot);
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_shot2.default, { data: data, metadata: metadata, policies: policies })
	  );
	};
	
	exports.default = (0, _styles.withStyles)(_site2.default)(Shot);
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-shot-shot-js-d3a15278542c5770213e.js